'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import styles from '@/app/not-found.module.css';

/**
 * Localized 404 page for (site) route group with Interface Audit dark theme.
 */

const i18n = {
  en: {
    title: "This page took Fitts's Law too literally",
    description: "It moved so far away, even we can't find it.",
    subdescription: "But don't worry—unlike this page, our audit is always ready when you need it.",
    goHome: "Go Home",
    viewSample: "View Sample Report",
    principles: "UX Principles",
    citations: "Categories",
    analysisTime: "Analysis Time",
  },
  es: {
    title: "Esta pagina se tomo la Ley de Fitts muy en serio",
    description: "Se alejo tanto que ni nosotros podemos encontrarla.",
    subdescription: "Pero no te preocupes—a diferencia de esta pagina, nuestra auditoria siempre esta lista cuando la necesitas.",
    goHome: "Ir al Inicio",
    viewSample: "Ver Reporte de Ejemplo",
    principles: "Principios UX",
    citations: "Categorías",
    analysisTime: "Tiempo de Analisis",
  },
};

export default function NotFound() {
  const pathname = usePathname();
  const locale = (pathname?.split('/')[1] as 'en' | 'es') || 'en';
  const t = i18n[locale] || i18n.en;

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {/* Glow effects */}
        <div className={styles.glowOrb1} />
        <div className={styles.glowOrb2} />

        {/* 404 indicator */}
        <div className={styles.errorCode}>
          <span className={styles.errorCodeText}>404</span>
        </div>

        <h1 className={styles.title}>{t.title}</h1>
        <p className={styles.description}>{t.description}</p>
        <p className={styles.subdescription}>{t.subdescription}</p>

        {/* Action buttons */}
        <div className={styles.actions}>
          <Link href={`/${locale}`} className={styles.primaryButton}>
            {t.goHome}
          </Link>
          <Link href={`/${locale}/demo-report`} className={styles.secondaryButton}>
            {t.viewSample}
          </Link>
        </div>

        {/* Stats bar */}
        <div className={styles.statsBar}>
          <div className={styles.stat}>
            <span className={styles.statValue}>167</span>
            <span className={styles.statLabel}>{t.principles}</span>
          </div>
          <div className={styles.statDivider} />
          <div className={styles.stat}>
            <span className={styles.statValue}>12</span>
            <span className={styles.statLabel}>{t.citations}</span>
          </div>
          <div className={styles.statDivider} />
          <div className={styles.stat}>
            <span className={styles.statValue}>&lt;30s</span>
            <span className={styles.statLabel}>{t.analysisTime}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
